import { render, staticRenderFns } from "./VetBackground.vue?vue&type=template&id=49c5fcdc&scoped=true"
import script from "./VetBackground.vue?vue&type=script&lang=js"
export * from "./VetBackground.vue?vue&type=script&lang=js"
import style0 from "./VetBackground.vue?vue&type=style&index=0&id=49c5fcdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5fcdc",
  null
  
)

export default component.exports